// removed by extract-text-webpack-plugin
module.exports = {"login-passcode-wrapper":"Passcode__login-passcode-wrapper","loginPasscodeWrapper":"Passcode__login-passcode-wrapper","signed-in-with":"Passcode__signed-in-with","signedInWith":"Passcode__signed-in-with"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/Passcode.scss
// module id = 1666
// module chunks = 8